import UpcomingScheduledMessagesView from './components/UpcomingScheduledMessagesView';
import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/upcoming-scheduled-messages'),
    name: 'upcoming_scheduled_messages',
    roles: [
      'administrator',
      'agent',
      'supervisor',
      'team_supervisor',
      'seller',
    ],
    component: UpcomingScheduledMessagesView,
    props: () => {
      return { inboxId: 0 };
    },
  },
];